import script from "./AppSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSurvey.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__